'use client'

import React from 'react'
import { MaximizeSquare, MinimizeSquareMinimalistic } from 'solar-icons'
import { useFullscreen } from '@/lib/hooks'
import { cn } from '@/lib/utils'

import { Button, ButtonProps } from '@/components/ui'

export const FullScreenButton = ({ className, ...restProps }: ButtonProps) => {
  const { isFullscreen, toggleFullscreen } = useFullscreen()

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => toggleFullscreen()}
      className={cn('p-0', className)}
      {...restProps}
    >
      {isFullscreen ? (
        <MinimizeSquareMinimalistic className="size-5" strokeWidth={1.5} />
      ) : (
        <MaximizeSquare className="size-5" strokeWidth={1.2} />
      )}
    </Button>
  )
}
